export const JiraServiceManagementMarkBrandV3 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="44"
        height="45"
        viewBox="0 0 44 45"
        fill="none"
    >
        <path
            d="M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z"
            fill="#FFC716"
        />
        <path
            d="M25.1173 19.2676H33.3C34.5289 19.2676 34.9485 20.4366 34.1992 21.3658L21.4006 37.1617C17.2642 33.8647 17.6539 28.6493 20.6812 24.8427L25.1173 19.2676ZM18.7929 25.562H10.6102C9.38126 25.562 8.96163 24.3931 9.71096 23.4639L22.5096 7.66797C26.6459 10.965 26.1963 16.1204 23.199 19.957L18.7929 25.562Z"
            fill="#101214"
        />
    </svg>
);
